/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Neat_Caring_Camel_ExploreInputs */

const fr_neat_caring_camel_explore = /** @type {(inputs: Neat_Caring_Camel_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir`)
};

/**

* @param {Neat_Caring_Camel_ExploreInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const neat_caring_camel_explore = /** @type {((inputs?: Neat_Caring_Camel_ExploreInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Neat_Caring_Camel_ExploreInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_neat_caring_camel_explore(inputs)
});